// 宁夏惠泽招
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
       
        {
            title: 'CA办理/续费',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '惠泽招电子招投标交易平台',//全称
        title2: '惠泽招',//简称
        jc_title: '惠泽招',//简称
        citycode:'640000',//城市编号
        planName:'nxhzz',
        caType:'nxhzzcaapply',
        caHref:'https://online.cwca.com.cn/',//CA申请链接
        meta: {
            description: '惠泽招电子招投标交易平台,交易平台,招投标,电子交易平台',
            keywords: '惠泽招电子招投标交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/nxhzz/favicon.ico',
        logoUrl: '/nxhzz/images/logo.png',//首页LOGO
        loginImgUrl: '/nxhzz/images/loginImg.png',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://tb.huizezhao.cn/#/login?plan=nxhzz',
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://tb.huizezhao.cn/#/login?plan=nxhzz',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=tender',
                title: '采购人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://pb.huizezhao.cn/?plan=nxhzz',
                title: '评标登录',
                class: ''
            },
        ],
        userRolesZfcg:[
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://tb.huizezhao.cn/#/login?plan=nxhzz',
                title: '投标人登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://dl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=agent',
                subHref: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=agent',
                title: '招标代理登录',
                class: '',
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://zfcgdl.huizezhao.cn/otc/#/login?plan=nxhzz&mRole=tender',
                title: '采购人登录',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://pb.huizezhao.cn/?plan=nxhzz',
                title: '评标登录',
            }
        ],
        friendLinks:[
            {
                href: 'https://ggzyjy.fzggw.nx.gov.cn',
                title: '宁夏回族自治区公共资源交易中心网站'
            },
            {
                href: 'https://www.ccgp-ningxia.gov.cn/index.html',
                title: '宁夏回族自治区政府采购网'
            },
            {
                href: 'https://www.nx.gov.cn/',
                title: '宁夏回族自治区人民政府网站'
            },
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: 'http://www.ccgp.gov.cn/',
                title: '中国政府采购网'
            },
            {
                href: 'https://www.creditchina.gov.cn/',
                title: '信用中国'
            },
            {
                href: 'https://wenshu.court.gov.cn/',
                title: '中国裁判文书网'
            },
            {
                href: 'https://www.nxjscx.com.cn/',
                title: '宁夏建筑市场监管服务系统'
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '400-630-6886', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'nxhuizezhao@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '宁夏惠泽招科技发展有限公司',  //运营公司名称
        companyAddress: '宁夏回族自治区银川市金凤区长城中路街道盈华商厦西塔17层',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'宁ICP备2023000622号-1',
        gwIcp:'宁公网安备64010602001060',
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
        isHiddenZiRanRen: true, //注册页面 用户类型是否隐藏自然人
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'https://www.huizezhao.cn/',
            changeOrigin:true,
        },
    },
}